module.exports = __webpack_public_path__ + "img/expandorminimize.eddffe3d.svg";